import { ResponsivePie, MayHaveLabel } from "@nivo/pie";
import { palette } from "./constants";
import {
  Histogram,
  validateHistogram,
} from "@/features/survey-results/survey-results-types";

interface PieChartProps {
  histogram?: Histogram;
}

const PieChart: React.FC<PieChartProps> = ({ histogram }) => {
  if (!histogram || histogram.length == 0) {
    return <div className="text-slate-400">No data</div>;
  }
  try {
    validateHistogram(histogram);
  } catch (error) {
    console.error("Error validating histogram:", error);
    return <div className="text-red-600">{String(error)}</div>;
  }
  const data = formatData(histogram);
  if (!data.length) {
    return <div className="text-slate-400">No data</div>;
  }
  return (
    <ResponsivePie
      data={data}
      colors={palette}
      arcLinkLabelsTextColor="white"
      innerRadius={0.5}
      padAngle={1} // Spacing between each arc
      cornerRadius={0}
      activeOuterRadiusOffset={4} // Zoom effect on hover
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      arcLinkLabelsSkipAngle={(5 / 100) * 360} // Don't draw labels (outside the slice) if arc is smaller than this threshold
      arcLabelsSkipAngle={(10 / 100) * 360} // Don't draw labels (inside the slice) if arc is smaller than this threshold
      // arcLinkLabelsThickness={2}
      // arcLinkLabelsColor={{ from: "color" }}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", 2]],
      }}
      tooltip={(tooltip: any) => (
        <div
          style={{
            padding: "10px",
            backgroundColor: "#333",
            color: tooltip.datum.color,
            borderRadius: "5px",
            fontSize: "14px",
          }}
        >
          <strong>{tooltip.datum.id}</strong>: {tooltip.datum.value}
        </div>
      )}
    />
  );
};

function formatData(histogram: Histogram): MayHaveLabel[] {
  return histogram.map((x) => ({
    id: x.choice,
    label: x.choice,
    value: x.count,
  }));
}

export default PieChart;
